import styled from '@emotion/styled';
import { Chip, Typography } from '@material-ui/core';
import { createElement, FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import ProjectEditingStep from '../../../entity/ProjectEditingStep';
import { useGetIsPC } from '../../../utilityHooks/useGetIsPC';
import { SPACING_REGULAR } from '../../constant/spacing';
import { context as StateContext } from '../../context/state';
import { isPointRequired } from '../../page/ProjectEditingPage/domain/helperFunctions';
import { useGetInputtedPointTotal, useGetOrderTotal } from '../../page/ProjectEditingPage/hooks/useGetTotal';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = {
  step: ProjectEditingStep;
};

const InputtedProjectPointTotal: FC<Props> = ({ step }) => {
  const isPC = useGetIsPC();
  const {
    lastAccessedOrganization,
    acct: { productPricing },
  } = useContext(StateContext);

  const inputtedPointTotal = useGetInputtedPointTotal(step);
  const orderTotal = useGetOrderTotal();

  return isPointRequired(lastAccessedOrganization) && productPricing && isPC ? (
    <Root>
      <Chip
        label={
          <Typography variant="body2" color="inherit">
            <FormattedMessage id="project_editing_page.total_orders.label" />:{orderTotal || 0}
          </Typography>
        }
        color="default"
      />
      <Spacer />
      <Chip
        label={
          <Typography variant="body2" color="inherit">
            <FormattedMessage id="project_editing_page.total_point.label" />:{productPricing.currency}
            {((inputtedPointTotal || 0) * productPricing.flatRate).toLocaleString()}
          </Typography>
        }
        color="default"
      />
    </Root>
  ) : null;
};

const Root = styled('div')`
  ${flexibleLayoutContainer({
    justifyContent: 'flex-end',
    alignItems: 'center',
  })}
  margin-bottom: ${SPACING_REGULAR}px;
`;

const Spacer = styled('div')`
  width: ${SPACING_REGULAR}px;
`;

export default InputtedProjectPointTotal;
